import { Symbol } from './Symbol';
import { circle } from './billboard-icon-parts/circle';

interface BillboardCircleProps {
    color: string;
    shouldIncludeBorder: boolean;
    borderColor: string;
}
export function BillboardCircle({ color, shouldIncludeBorder, borderColor }: BillboardCircleProps) {
    const symbol = Symbol({ icon: circle, strokeWidth: 8 });
    const use = `
        <use
            href="#${circle.id}"
            x="88"
            y="88"
            width="208"
            height="208"
            fill="${color}"
            stroke="${shouldIncludeBorder ? borderColor : color}"
        />`;

    return symbol + use;
}
